<template>
  <main class="app-main" v-bar="{
      useScrollbarPseudo: true,
      overrideFloatingScrollbar: true,
  }">
    <section class="work-area--picture">
      <h2 class="picture-title">Картина дня по ленте {{threadName}}</h2>
      <div class="picture-wrap" id="picture">
        <div class="picture">
          <vk></vk>
          <fb></fb>
          <tw></tw>
          <gs></gs>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// vuex
import { mapGetters } from 'vuex';
import { SET_INNER_PAGE } from '../../store/actions/pages';

// components
import Vk from './components/Vk.vue';
import Fb from './components/Fb.vue';
import Tw from './components/Tw.vue';
import Gs from './components/Gs.vue';

export default {
  name: 'Picture',
  components: {
    Vk,
    Fb,
    Tw,
    Gs
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(SET_INNER_PAGE, '');
    next();
  },
  computed: {
    ...mapGetters([
      'threadName',
    ]),
  },
  mounted() {
    this.$store.dispatch(SET_INNER_PAGE, this.$route.name);
  },
};
</script>
